module.exports = __webpack_public_path__ + "static/media/Konigsee_woods_warm_fall.420de76b.jpg";